import React from 'react';
import { useHistory } from "react-router-dom";
import IntentForm from './IntentFormComponent';
import { postIntent } from '../routing/routes';

const NuevoIntent = ({intents,refreshData,setNotification}) => {
    const history = useHistory();
    const defaultIntent = {intent:'', examples:[{phrase:"", trained:false}]}
    function create(nuevoIntent){
        postIntent(nuevoIntent)
        .catch(error => {setNotification("eOcurrió un error creando el intent!");console.error('Error:', error)})
        .then((res) => {
            refreshData()
            history.push("/intents/edit/"+res.insertedId)
            setNotification("mIntent creado correctamente!")     
        });
    }

    return <IntentForm intent={defaultIntent} intents={intents} guardarIntent={create} history={history} editing={false}/>
}

export default NuevoIntent;